<div id="menu2" class="tab-pane teamLeaveTable"  [intouchloader2]="isLoader">
    <ul class="caldBtmIcon">
        <!-- <li><a href="#" class="fullscreenToggle"><i class="material-icons">fullscreen</i></a></li> -->
    </ul>
    <div class="attendTable">
        <div class="reportpanel mCustomScrollbar" data-mcs-theme="minimal-dark">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th *ngFor= "let header of teamApprovalHeaderList" scope="col">
                                <p>{{header.name}}</p>
                                <div  *ngIf="header.name == 'Employee Name'" class="emFilterDiv dropdown">
                                   
                                        <a href="#" class="emFilterIcon dropdown-toggle" data-toggle="dropdown"><i class="material-icons"
                                                >group</i></a>
                                        <div class="dropdown-menu">
                                            <div class="inputSec">
                                                <a href="#" class="searchIcon"><i class="material-icons">search</i></a>
                                                <input class="inputfield" type="text" value="" placeholder="Search for users" [(ngModel)]="fieldUserSearch">
                                            </div>
                                            <ul class="membersList">
                                                <ng-container *ngIf="userList  | customSearchPipe:fieldUserSearch:filteredData:searchableHeaderKeys as list">
                                                    <li *ngFor="let user of list" (change)="onSelectedUserChange(user);">
                                                        <label>
                                                            <input type="checkbox" name="" [(ngModel)]="user.checked" class="checkbox">
                                                            <div  *ngIf="!user.profileDocId || 
                                                            ( user.profileDocId && (user.profileDocId == '122c379e-ddc6-44cc-9794-d5872fca5725' || user.profileDocId == '63f48c6b-b477-424d-97fc-0be04d3361a4'))"
                                                             class="peopleText {{user.randomColorClass}}">{{getShortName(user)}}</div>
                                                            <div class="peopleText pic" *ngIf="user.profileDocId">
                                                                <img src="{{imageUrl}}{{user.profileDocId}}">
                                                            </div>
                                                            {{user.userName}}
                                                        </label>
                                                    </li>
                                        
                                                </ng-container>
                                            </ul>
                                      
                                    </div>
                                </div>
                            </th>
                            <!-- <th scope="col">
                                <p>Leave Type</p>
                            </th>
                            <th scope="col">
                                <p>Duration</p>
                            </th>
                            <th scope="col">
                                <p>Count</p>
                            </th>
                            <th scope="col">
                                <p>Reason</p>
                            </th>
                            <th scope="col">
                                <p>Status</p>
                            </th> -->
                        </tr>
                    </thead>
                    <tbody *ngIf="teamLeavesList.length==0  &&  !isLoader  ">
                        <tr>
                            <div class="nodataDiv" >
                                <span class="nodataimg"><img src="assets/img/nodataImg.png" alt=""></span>
                                <p>No Attendance Marked</p>
                               
                            </div>
                        </tr>
                    </tbody>
                    <tbody>
                        <cdk-virtual-scroll-viewport itemSize="8" class="example-viewport">
                            <tr *cdkVirtualFor="let obj of teamLeavesList   | orderBy : 'creationTimestamp' :false; let i = index;">
                        <!-- <tr *ngFor="let obj of teamLeavesList   | orderBy : 'creationTimestamp' :false; let i = index;"> -->
                            <td>
                                <div class="elPicDiv">
                                    <div *ngIf="obj.profileDocId" class="peopleText pic">
                                        <!-- <img src="assets/img/aakash.png" alt="" class="mCS_img_loaded"> -->
                                        <img src="{{imageBaseUrl}}{{obj.profileDocId}}" alt="" class="mCS_img_loaded">
                                    </div>
                                    <div *ngIf="!obj.profileDocId" class="peopleText {{obj.randomColorClass}}" >
                                        
                                            {{getShortName(obj)}}
                                       
                                    </div>
                                    <div class="elPicDivCont"> <span>{{obj.userName ? obj.userName : '-'}}</span></div>
                                </div>
                            </td>
                            <td>
                                <p><span class="leaveDot el01" [ngStyle]="{'background-color': obj.leaveTypeColorCode}"></span>{{obj.leaveTypeStr}}</p>
                            </td>
                            <td *ngIf="obj.fromTimestamp && obj.toTimestamp">
                                <p>{{obj.fromTimestamp * 1000  |date:'dd MMM yyyy'}} - {{obj.toTimestamp * 1000  |date:'dd MMM yyyy'}}</p>
                            </td>
                            <td *ngIf="!obj.fromTimestamp || !obj.toTimestamp">
                                <p>-</p>
                            </td>
                            <td>
                                <p>{{obj.count ? obj.count : '-'}}</p>
                            </td>
                            <td>
                                <p>{{obj.reason ? obj.reason : '-'}}</p>
                            </td>
                            <td>
                                <p  [ngStyle]="{'color': obj.statusClass}">{{obj.statusStr ? obj.statusStr : '-'}}</p>
                            </td>
                            <td>
                                <div class="formSec">
                                   <div class="selectboxSec">
                                    <ng-select class="select form-control e1" 
                                    [items]="statusList" 
                                    bindLabel="text"
                                    [virtualScroll]="true" 
                                    [closeOnSelect]="true" 
                                    [(ngModel)]="obj.statusObject" 
                                    name="status{{i}}"
                                    [clearable]="false"
                                    (change) ="statusChange(obj)"
                                    placeholder="Select Action" 
                                    [ngClass]="obj.statusObject ? 'selectfocus': ''">
                                    <ng-template ng-label-tmp let-item="item">
                                        <div [ngStyle]="{'color': item.colorClass}">{{item.text}}</div>
                                       
                                     </ng-template>
                
                                     <ng-template ng-option-tmp let-item="item" let-index="index">
                                        <div [ngStyle]="{'color': item.colorClass}">{{item.text}}</div>
                                      
                                      </ng-template>
                                 </ng-select>
                                </div>
                                </div>
                            </td>
                            
                        </tr>
                        <!-- <tr>
                            <td>
                                <div class="elPicDiv">
                                    <div class="peopleText"><img src="img/picImg01.png" alt="" class="mCS_img_loaded">
                                    </div>
                                    <div class="elPicDivCont"> <span>Vinay Verma</span></div>
                                </div>
                            </td>
                            <td>
                                <p><span class="leaveDot el02"></span>Flexi</p>
                            </td>
                            <td>
                                <p>13 Jan 2021 - 17 Jan 2021 </p>
                            </td>
                            <td>
                                <p>5</p>
                            </td>
                            <td>
                                <p>Going on trip with my family... <a href="#" class="infoIcon"><img
                                            src="img/infoIcon.png" alt=""></a></p>
                            </td>
                            <td>
                                <div class="table-action-ctrl">
                                    <div class="dropdown">
                                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" type="button"><span
                                                class="attendStatus statusCode02">Approved</span><i
                                                class="material-icons">keyboard_arrow_down</i></a>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#">Pending </a>
                                            <a class="dropdown-item" href="#">Approve </a>
                                            <a class="dropdown-item" href="#">Reject </a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                       -->
                        </cdk-virtual-scroll-viewport>
                    </tbody>
                    
                </table>
            </div>
        </div>
    </div>
</div>